import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { SettingsProvider, useSettings } from "@/context/SettingsContext";
import { CartDrawer } from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Store from "@/pages/Store";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import ComingSoon from "@/pages/ComingSoon";

const Gate = ({ children }) => {
  const { comingSoon, ready } = useSettings();
  const { user, ready: authReady } = useAuth();
  if (!ready || !authReady) return <div className="bg-paper min-h-screen" />;
  if (comingSoon && !user) return <ComingSoon />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SettingsProvider>
          <CartProvider>
            <BrowserRouter>
              <CartDrawer />
              <Toaster position="top-center" toastOptions={{ style: { fontFamily: "JetBrains Mono, monospace" } }} />
              <Routes>
                <Route path="/" element={<Gate><Home /></Gate>} />
                <Route path="/store" element={<Gate><Store /></Gate>} />
                <Route path="/login" element={<Login />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </BrowserRouter>
          </CartProvider>
        </SettingsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
